enum SubscriptionAnomalyReason {
  PERMANENTLY_STOPPED = 'PERMANENTLY_STOPPED',
  FROZEN = 'FROZEN',
  DELAYED = 'DELAYED',
  BACKEND_DETECTED = 'BACKEND_DETECTED',
  USER_HIDDEN = 'USER_HIDDEN',
  FREQUENCY_CHANGE = 'FREQUENCY_CHANGE',
  DEFAULT = 'DEFAULT',
}

export default SubscriptionAnomalyReason;
